import * as React from "react";
import { cn } from "@/lib/utils";
import { TONES, type Tone } from "@/lib/tones";

export interface PillProps extends React.HTMLAttributes<HTMLSpanElement> {
  tone: Tone;
  /** show the leading dot (tone.dot color); ignored when the tone has no dot */
  withDot?: boolean;
}

/**
 * Semantic pill used across the База table, facet chips and touch cart.
 * Geometry (README §pills / mockup renderVals): r6, 11.5px/500, padding 2.5px 8px,
 * inline-flex, gap 6px, leading dot 6px.
 */
export function Pill({
  tone,
  withDot = false,
  className,
  style,
  children,
  ...rest
}: PillProps) {
  const spec = TONES[tone];
  const showDot = withDot && spec.dot != null;
  return (
    <span
      className={cn("inline-flex items-center whitespace-nowrap", className)}
      style={{
        backgroundColor: spec.bg,
        color: spec.fg,
        borderRadius: 6,
        fontSize: "11.5px",
        fontWeight: 500,
        lineHeight: 1,
        padding: "2.5px 8px",
        gap: 6,
        ...style,
      }}
      {...rest}
    >
      {showDot && (
        <span
          aria-hidden
          style={{
            width: 6,
            height: 6,
            borderRadius: "50%",
            backgroundColor: spec.dot as string,
            flex: "0 0 auto",
          }}
        />
      )}
      {children}
    </span>
  );
}

export default Pill;
